import type { LeadStato, LeadWarning } from '@/types';

/**
 * Same graph as `LEAD_TRANSITIONS` on the amministrazione service.
 * `qualificato → convertito` is POST /admin/lead/:id/converti, not a stato patch.
 */
export const LEAD_TRANSITIONS: Record<LeadStato, readonly LeadStato[]> = {
  nuovo: ['contattato', 'da_richiamare', 'appuntamento_fissato', 'perso'],
  contattato: ['da_richiamare', 'appuntamento_fissato', 'qualificato', 'perso'],
  da_richiamare: ['contattato', 'appuntamento_fissato', 'qualificato', 'perso'],
  appuntamento_fissato: ['contattato', 'da_richiamare', 'qualificato', 'perso'],
  qualificato: ['da_richiamare', 'appuntamento_fissato', 'perso'],
  perso: ['contattato', 'nuovo', 'da_richiamare'],
  convertito: [],
};

export function leadNextStati(stato: LeadStato): readonly LeadStato[] {
  return LEAD_TRANSITIONS[stato];
}

const CONVERTIBILI: readonly LeadStato[] = [
  'nuovo',
  'contattato',
  'da_richiamare',
  'appuntamento_fissato',
  'qualificato',
];

export function canConvertLead(lead: { stato: LeadStato; anonimizzato_at?: string | null }): boolean {
  return CONVERTIBILI.includes(lead.stato) && !lead.anonimizzato_at;
}

export function canQuoteLead(lead: { stato: LeadStato; anonimizzato_at?: string | null }): boolean {
  return canConvertLead(lead);
}

export function leadLabel(lead: {
  ragione_sociale?: string | null;
  referente_nome?: string | null;
  referente_email?: string | null;
  referente_telefono?: string | null;
}): string {
  return (
    lead.ragione_sociale?.trim() ||
    lead.referente_nome?.trim() ||
    lead.referente_email?.trim() ||
    lead.referente_telefono?.trim() ||
    'Lead senza nome'
  );
}

export function canEditLead(lead: { anonimizzato_at?: string | null }): boolean {
  return !lead.anonimizzato_at;
}

/** A pipeline lead can take an appointment. An existing one can be updated in place. */
export function canBookAppointment(lead: { stato: LeadStato; anonimizzato_at?: string | null }): boolean {
  if (lead.anonimizzato_at) return false;
  return lead.stato === 'appuntamento_fissato' || leadNextStati(lead.stato).includes('appuntamento_fissato');
}

export function leadWarningText(warning: LeadWarning): string {
  if (warning.code === 'dominio_cliente_esistente') {
    return 'Il dominio email è già usato da un cliente.';
  }
  return 'Il dominio email è già usato da un altro lead.';
}
